import { AccordionDetails, Grid } from "@mui/material";

import { useState } from "react";
import { converDecimalToAmerican } from "../App";

export default function GameItem({
  branch,
  odds,
  i,
  urlPrfix,
  country,
  betSlipPrefix,
}) {
  function replaceSpanishCharacters(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  // const urlPrfix = "https://m.apuestas.codere.es/deportes/#/MercadosPage?";

  const [showMore, setShowMore] = useState(true);

  const dateHandler = (date) => {
    const tempDate = new Date(date);
    const options = {
      day: "numeric",
      month: "long",
      hour: "2-digit",
      minute: "2-digit",
    };

    const time = tempDate.toLocaleString("es-sp", options).split(",")[1];

    if (tempDate.getDate() === new Date().getDate()) return `hoy ${time}`;
    else if (tempDate.getDate() === new Date().getDate() + 1)
      return `mañana ${time}`;
    // else return "boy";
    return tempDate.toLocaleString("es-sp", options);
  };

  const urlHandler = (game, index, flag) => {
    if (flag)
      return `${betSlipPrefix}?addbet=${game.Games[0].Results[index].NodeId}`;
    return `${urlPrfix}?NodeId=${
      game.NodeId
    }&LeagueName=${replaceSpanishCharacters(
      game.LeagueName
    )}&Name=${replaceSpanishCharacters(
      game.Name
    )}&SportHandle=${replaceSpanishCharacters(
      game.SportHandle
    )}&SportName=${replaceSpanishCharacters(
      game.SportName
    )}&StartDate=/Date(${new Date(game.StartDate).getTime()})/`;
  };

  return (
    <>
      {branch.length > 0 && (
        <AccordionDetails className="acc-details-container">
          <div className={`acc-details ${!showMore ? "collapsed" : ""}`}>
            {branch.slice(0, showMore ? 3 : 6).map((game, j) => (
              <div key={j} className="acc-body">
                <p className="date">{dateHandler(game.StartDate)}</p>

                <Grid
                  style={{
                    justifyContent: `space-${
                      odds[i][j].length === 2 ? "evenly" : "around"
                    }`,
                  }}
                  className="grided"
                  key={j}
                  container
                  spacing={4}
                >
                  <Grid className="names" md={4} xs={4}>
                    <p>{game.Name.split(" - ")[0]}</p>
                    <p>{game.Name.split(" - ")[1]}</p>
                  </Grid>

                  {/* {console.log(game.Games[0].Results[j].NodeId)} */}
                  {odds[i][j].map((_, index) => (
                    <Grid
                      onClick={() =>
                        window.open(urlHandler(game, index, 1), "_blank")
                      }
                      className="odd-grid"
                      key={index}
                      md={odds[i][j].length === 2 ? 3 : 2}
                      xs={3}
                      rel="nofollow"
                    >
                      <p>
                        {index + 1 === 2 && odds[i][j].length > 2
                          ? "x"
                          : index === 2
                          ? index
                          : index + 1}
                      </p>
                      <p>
                        {converDecimalToAmerican(
                          odds[i][j][index],
                          ["panama", "mexico"].includes(country)
                        )
                          .toString()
                          .replaceAll(".", ",")}
                      </p>
                    </Grid>
                  ))}
                </Grid>
              </div>
            ))}
            <div onClick={() => setShowMore(!showMore)} className="ver">
              Ver {showMore ? "más" : "menos"}
            </div>
          </div>
        </AccordionDetails>
      )}
    </>
  );
}
